var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.503 18.826"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-date_svg__Icon_-_Date",
    "data-name": "Icon - Date",
    transform: "translate(-.225 .025)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "icon-date_svg__Rectangle_286",
    "data-name": "Rectangle 286",
    width: 17.003,
    height: 15.788,
    rx: 4.245,
    transform: "translate(.975 2.263)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-date_svg__Line_191",
    "data-name": "Line 191",
    transform: "translate(1.561 7.728)",
    strokeLinejoin: "round",
    d: "M0 0h15.788"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-date_svg__Line_192",
    "data-name": "Line 192",
    transform: "translate(5.533 .725)",
    strokeLinejoin: "round",
    d: "M0 3.076V0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-date_svg__Path_3957",
    "data-name": "Path 3957",
    d: "M0 3.076V0",
    transform: "translate(13.376 .725)"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOC41MDMgMTguODI2Ij4KICA8ZyBpZD0iSWNvbl8tX0RhdGUiIGRhdGEtbmFtZT0iSWNvbiAtIERhdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjIyNSAwLjAyNSkiPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8yODYiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDI4NiIgd2lkdGg9IjE3LjAwMyIgaGVpZ2h0PSIxNS43ODgiIHJ4PSI0LjI0NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC45NzUgMi4yNjMpIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogICAgPGxpbmUgaWQ9IkxpbmVfMTkxIiBkYXRhLW5hbWU9IkxpbmUgMTkxIiB4Mj0iMTUuNzg4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjU2MSA3LjcyOCkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8bGluZSBpZD0iTGluZV8xOTIiIGRhdGEtbmFtZT0iTGluZSAxOTIiIHkxPSIzLjA3NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNS41MzMgMC43MjUpIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogICAgPHBhdGggaWQ9IlBhdGhfMzk1NyIgZGF0YS1uYW1lPSJQYXRoIDM5NTciIGQ9Ik0wLDMuMDc2VjAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzLjM3NiAwLjcyNSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgIconDate as ReactComponent };